import { EMPTY_ACCESS } from "@mattoboard/schemas";

// The Teams sharing fields on boards, projects, collections, schedules and
// concepts. Only the backend changes them after a create; the client stamps
// a fresh set on create and keeps every other write clear of them.
export const ACCESS_FIELDS = ["created_by", "access", "readers", "editors"] as const;

export type AccessFieldName = (typeof ACCESS_FIELDS)[number];

// What a new or copied item starts with: private, the creator alone.
export const freshAccessFields = (uid: string) => ({
  created_by: uid,
  access: { ...EMPTY_ACCESS, members: {} },
  readers: [uid],
  editors: [uid],
});

// For whole-document merge saves: omitting the fields leaves them untouched.
export function stripAccessFields<T extends object>(
  doc: T,
): Omit<T, AccessFieldName> {
  const out = { ...(doc as Record<string, unknown>) };
  for (const field of ACCESS_FIELDS) delete out[field];
  return out as Omit<T, AccessFieldName>;
}

// For whole-document replacements (tx.set): the stored values win.
export function carryAccessFields<T extends object>(
  data: T,
  stored: Record<string, unknown>,
): T {
  const out = data as Record<string, unknown>;
  for (const field of ACCESS_FIELDS) {
    if (stored[field] !== undefined) out[field] = stored[field];
    else delete out[field];
  }
  return data;
}
